export default "__VITE_ASSET__DZ_2JiVY__"